import React, { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { User, ArrowLeft } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { useCustomerAuth } from "../context/CustomerAuthContext";

export default function CustomerLogin() {
  const { customer, login } = useCustomerAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (customer) return <Navigate to="/area-clienti" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/area-clienti");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <section className="flex-1 bg-surface flex items-center justify-center px-5 py-16">
        <div className="w-full max-w-md bg-white rounded-3xl border border-line soft-shadow-lg p-8 sm:p-10" data-testid="customer-login-card">
          <Link to="/" className="inline-flex items-center gap-2 text-xs text-navy-soft hover:text-brand mb-6">
            <ArrowLeft className="w-3.5 h-3.5" /> Torna alla home
          </Link>
          <div className="w-12 h-12 rounded-2xl bg-brand-light text-brand-darker flex items-center justify-center mb-5">
            <User className="w-6 h-6" />
          </div>
          <h1 className="font-heading font-extrabold text-3xl text-navy">Area Clienti</h1>
          <p className="text-sm text-navy-soft mt-2">Accedi per vedere la tua Carta Fedeltà e i tuoi punti.</p>

          <form onSubmit={handleSubmit} className="mt-7 space-y-5">
            <div>
              <label className="label-eyebrow text-navy-soft">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="customer-email-input"
                className="w-full bg-surface border border-line focus:border-brand rounded-xl px-4 py-3 outline-none transition-colors text-navy"
                placeholder="latua@email.it"
              />
            </div>
            <div>
              <label className="label-eyebrow text-navy-soft">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                data-testid="customer-password-input"
                className="w-full bg-surface border border-line focus:border-brand rounded-xl px-4 py-3 outline-none transition-colors text-navy"
                placeholder="••••••••"
              />
            </div>
            {error && <div className="text-sm text-destructive font-medium" data-testid="customer-login-error">{error}</div>}
            <button
              type="submit"
              disabled={loading}
              data-testid="customer-login-submit"
              className="w-full bg-brand hover:bg-brand-dark text-white font-bold py-3.5 rounded-full transition-colors disabled:opacity-60"
            >
              {loading ? "Accesso…" : "Accedi"}
            </button>
          </form>

          <p className="mt-6 text-center text-sm text-navy-soft">
            Non hai un account?{" "}
            <Link to="/area-clienti/registrati" data-testid="customer-go-register" className="font-bold text-brand-dark hover:underline">
              Registrati
            </Link>
          </p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
